const inuit = {
    type:''
}

export default inuit